import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Grid } from 'react-bootstrap';
import { PRODUCT_PAGE_TOGGLE_FILTER, PRODUCT_PAGE_TOGGLE_ADVANCED_FILTER } from '../../../reducers/productPageReducer';
import {
  filterByObjective, selectOutlet, filterByCategories, filterByNewProduct, filterByBrands,
  clearFilters, applyFilters
} from '../../../actions/product-page';

import ObjectiveFilter from './objective-filter';
import CategoriesFilter from './categories-filter';
import BrandsFilter from './brands-filter';
import FilterHeader from './filter-header';
import FilterFooter from './filter-footer';

import './style.css';

class Filters extends Component {
  toggleFilters = () => {
    const { dispatch, filterBox } = this.props;
    dispatch({type: PRODUCT_PAGE_TOGGLE_FILTER, payLoad: !filterBox.showFilters});
  };

  toggleAdvancedFilters = () => {
    const { dispatch, filterBox } = this.props;
    dispatch({type: PRODUCT_PAGE_TOGGLE_ADVANCED_FILTER, payLoad: !filterBox.showAdvancedFilters});
  };

  clearFilters = () => {
    const { dispatch } = this.props;
    dispatch(clearFilters());
  };

  applyFilters = () => {
    const { dispatch } = this.props;
    dispatch(applyFilters());
  };

  handleObjectiveFilterChange = (objectives) => {
    const {dispatch} = this.props;
    dispatch(filterByObjective(objectives));
  };

  handleOutletFilterChange = (outlet) => {
    const {dispatch} = this.props;
    dispatch(selectOutlet(outlet));
  };

  handleCategoryFilterChange = (categories) => {
    const {dispatch} = this.props;
    dispatch(filterByCategories(categories));
  };

  handleNewProductFilterChange = () => {
    const {dispatch} = this.props;
    dispatch(filterByNewProduct());
  };

  handleBrandFilterChange = (brands) => {
    const {dispatch} = this.props;
    dispatch(filterByBrands(brands));
  };

  componentDidUpdate(prevProps) {
    const { filterBox, isSticky, isIndeedSticky } = this.props;
    if (isSticky && !prevProps.isSticky && filterBox.showFilters) {
      this.toggleFilters();
    }

    if (!isSticky && prevProps.isSticky && !filterBox.showFilters && isIndeedSticky) {
      this.toggleFilters();
    }
  }

  render() {
    const { filter, filterBox, fetchingProducts } = this.props;
    const opacity = fetchingProducts ? '10%' : '100%';
    return (
      <div className="product-page-filter">
        <FilterHeader
          filterBox={filterBox}
          onToggleFilters={this.toggleFilters}
          fetchingProducts={fetchingProducts}
        />
        <div className='product-page-overlay' style={{opacity}}>
          {filterBox.showFilters && (
            <Grid fluid>
              <ObjectiveFilter
                outlets={filter.outlets}
                filterBox={filterBox}
                showStockIt={filter.special && filter.special['special-stock-it']}
                showPriceIt={filter.special && filter.special['special-price-it']}
                showSellIt={filter.special && filter.special['special-sell-it']}
                onObjectiveFilterChange={this.handleObjectiveFilterChange}
                onOutletFilterChange={this.handleOutletFilterChange}
                fetchingProducts={fetchingProducts}
              />
              {filterBox.showAdvancedFilters && (
                <CategoriesFilter
                  categories={filter.categories}
                  filterBox={filterBox}
                  onCategoryFilterChange={this.handleCategoryFilterChange}
                  onNewProductFilterChange={this.handleNewProductFilterChange}
                  fetchingProducts={fetchingProducts}
                />
              )}
              {filterBox.showAdvancedFilters && (
                <BrandsFilter
                  brands={filter.brands}
                  filterBox={filterBox}
                  onBrandFilterChange={this.handleBrandFilterChange}
                  fetchingProducts={fetchingProducts}
                />
              )}
              <FilterFooter
                showAdvancedFilters={filterBox.showAdvancedFilters}
                showObjectiveFilters={filterBox.showObjectiveFilters}
                onClearFilters={this.clearFilters}
                onToggleAdvancedFilters={this.toggleAdvancedFilters}
              />
            </Grid>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filter: state.productPage.filter,
  filterBox: state.productPage.filterBox,
  fetchingProducts: (state.productPage.fetching || state.productPage.fetchingMore)
});

export default connect(mapStateToProps)(Filters);



// WEBPACK FOOTER //
// ./src/components/product-page/filters/index.jsx